export default __webpack_public_path__ + "static/media/eva_gift-fill.93174034.svg";